import { isElectronWebview } from './feizhou-bridge.js'

export const FEIZHOU_DESKTOP_CLASS = 'feizhou-desktop'

/** PC Electron WebView 加桌面壳；App / 手机浏览器不加。 */
export function applyFeizhouDesktopShell(root = typeof document !== 'undefined' ? document.documentElement : null) {
  if (!root?.classList) return false
  if (!isElectronWebview()) return false
  root.classList.add(FEIZHOU_DESKTOP_CLASS)
  return true
}
